export default __webpack_public_path__ + "static/media/avatar.432abd57.jpg";